import React from 'react'

export interface ModalProps {
  children?: React.ReactNode;
  heading: string;
  onClose: () => void;
}

export const Modal: React.FC<ModalProps> = ({ children, heading, onClose }) => (
  // eslint-disable-next-line jsx-a11y/no-noninteractive-element-interactions, jsx-a11y/click-events-have-key-events
  <div
    className='ch-c-dialog-wrap'
    aria-labelledby='dialog-heading'
    role='dialog'
    onClick={(e) => e.stopPropagation()}
  >
    <div className='ch-c-dialog ds-u-padding--0' role='document'>
      <button
        tabIndex={0}
        className='ch-c-dialog__close-btn'
        aria-label='Close modal dialog'
        onClick={onClose}
        data-testid='modal-close-btn'
      >
        X
      </button>
      <header
        className='ch-c-dialog__header'
        role='banner'
        data-testid='modal-header'
      >
        <h1 className='ds-h2' id='dialog-heading'>
          {heading}
        </h1>
      </header>
      <main role='main'>{children}</main>
    </div>
  </div>
)
